
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';

export default function CtaSection() {
  return (
    <section className="py-24 bg-gradient-to-r from-taekwondo-blue/90 to-taekwondo-red/90 relative overflow-hidden">
      {/* Background pattern overlay */}
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxnIGZpbGw9IiNmZmYiIGZpbGwtb3BhY2l0eT0iMC4wNSI+PHBhdGggZD0iTTM2IDM0aDR2MWgtNHYtMXptMC0yaDF2NGgtMXYtNHptMTYgMGgxdjJoLTF2LTJ6bS04IDBoMXYyaC0xdi0yem0tOC0xaDJ2MWgtMnYtMXptOCAwaDJ2MWgtMnYtMXptOCAwaDJ2MWgtMnYtMXpNMCA0aDF2MkgwVjR6bTAgMTZoMXYySDB2LTJ6bTAgLThoMXYySDB2LTJ6Ii8+PC9nPjwvZz48L3N2Zz4=')] opacity-30"></div>
      
      <div className="container mx-auto px-4 text-center relative z-10">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-3xl md:text-5xl font-bold text-white font-display mb-6">
            Begin Your Taekwondo Journey Today
          </h2>
          <p className="text-white/90 text-lg max-w-2xl mx-auto mb-10 leading-relaxed">
            Join <span className="text-taekwondo-red font-bold">OMAC-UK</span> in Gedling, Nottingham and discover the transformative power of Taekwondo.
            Classes available for all ages and skill levels.
          </p>
          <div className="flex flex-wrap justify-center gap-6">
          <Button size="lg" asChild className="bg-taekwondo-red hover:bg-taekwondo-red/90 text-white rounded-md px-8 shadow-lg">
                <Link to="/contact">
                  Free Trial <ArrowRight className="ml-2 h-4 w-4" />
                </Link>
              </Button>
              <Button size="lg" asChild className="bg-[#024398] hover:bg-[#024398]/90 text-white rounded-md px-8 shadow-lg">
                <Link to="/schedule">
                  View Schedule
                </Link>
              </Button>
          </div>
          
          <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white/10 backdrop-blur-sm p-6 rounded-lg">
              <div className="text-white font-display text-xl font-bold mb-2">Lil Dragons</div>
              <p className="text-white/80 text-sm">Ages 4-7</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm p-6 rounded-lg">
              <div className="text-white font-display text-xl font-bold mb-2">Cadets</div>
              <p className="text-white/80 text-sm">Ages 8-12</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm p-6 rounded-lg">
              <div className="text-white font-display text-xl font-bold mb-2">Teens & Adults</div>
              <p className="text-white/80 text-sm">Ages 13+</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
